import React from 'react';
import styles from './EventsList.module.css';
import ACTION_TYPES from '../../shared/action_types';
import { Link } from 'react-router-dom';


const EventsList = ({ events }) => {
  return (
    <div className={styles.eventsList}>
      {events.map((event) => {
        const color = ACTION_TYPES[event.type];
        // Convert hex to rgba with 25% opacity
        const rgbaColor = color + '40'; // 40 in hex = 25% opacity
        
        return (
            <Link to={`/events/${event.id}`} key={event.id} className={styles.eventLink}>

            <div 
                key={event.id} 
                className={styles.eventItem}
                style={{ backgroundColor: rgbaColor }}
            >
                <h2>{event.title}</h2>
                <p className={styles.eventDate}>{event.date}</p>
                {/* <h3>{event.location_1}</h3> */}
                <p className={styles.eventDescription}>{event.location_1}</p>
                <p className={styles.eventDescription}>{event.location_2}</p>
                <br></br>
                <p className={styles.eventDescription}>{event.description}</p>
                
            </div>
          </Link>

        );
      })}
    </div>
  );
};

export default EventsList;